import dayjs from "dayjs";
import {
  OccupancyData,
  SchedulerProjectData,
  TimeUnits,
} from "./../types/global";
import { getDuration } from "./getDuration";
import { getTotalHoursAndMinutes } from "./getTotalHoursAndMinutes";
import { getTimeOccupancy } from "./getTimeOccupancy";
import { IHoliday } from "../../@types/holiday.type";
import { getIsHoliday } from "./dates";

export const getDayOccupancy = (
  occupancy: SchedulerProjectData[],
  focusedDate: dayjs.Dayjs,
  zoom: number,
  includeTakenHoursOnWeekendsInDayView: boolean,
  listHolidays: IHoliday[]
): OccupancyData => {
  const focusedDayNum = focusedDate.isoWeekday();

  function getHoursAndMinutes(occupancy: SchedulerProjectData[]): TimeUnits[] {
    return occupancy.map((item) => {
      const { hours: itemHours, minutes: itemMinutes } = getDuration(
        Math.round(item.hoursPerDay) * 60 * 60
      );

      if (getIsHoliday(focusedDate, listHolidays)) {
        return { hours: 0, minutes: 0 };
      }

      // if config was set to include free weekends max day num is 5 - friday else is 7 - whole week
      if (focusedDayNum <= (includeTakenHoursOnWeekendsInDayView ? 7 : 5)) {
        return { hours: itemHours, minutes: itemMinutes };
      }

      return { hours: 0, minutes: 0 };
    });
  }

  const allocationOcupancy: SchedulerProjectData[] = [];
  const allocationGroupOcupancy: SchedulerProjectData[] = [];
  const unavailabilityOcupancy: SchedulerProjectData[] = [];
  const projectionOcupancy: SchedulerProjectData[] = [];

  for (const item of occupancy) {
    if (item.isProjection) projectionOcupancy.push(item);
    else if (!item.isProject) unavailabilityOcupancy.push(item);
    else if (item.linkId) allocationGroupOcupancy.push(item);
    else allocationOcupancy.push(item);
  }

  const { hours: totalHours, minutes: totalMinutes } = getTotalHoursAndMinutes(
    getHoursAndMinutes(occupancy)
  );
  const { free, overtime } = getTimeOccupancy(
    { hours: totalHours, minutes: totalMinutes },
    zoom
  );

  return {
    taken: {
      hours: Math.max(0, totalHours),
      minutes: Math.max(0, totalMinutes),
    },
    free,
    overtime,
    allocation: allocationOcupancy.length
      ? getTotalHoursAndMinutes(getHoursAndMinutes(allocationOcupancy))
      : { hours: 0, minutes: 0 },
    allocationGroup: allocationGroupOcupancy.length
      ? getTotalHoursAndMinutes(getHoursAndMinutes(allocationGroupOcupancy))
      : { hours: 0, minutes: 0 },
    unavailability: unavailabilityOcupancy.length
      ? getTotalHoursAndMinutes(getHoursAndMinutes(unavailabilityOcupancy))
      : { hours: 0, minutes: 0 },
    projection: projectionOcupancy.length
      ? getTotalHoursAndMinutes(getHoursAndMinutes(projectionOcupancy))
      : { hours: 0, minutes: 0 },
  };
};
